(function () {
	function setRem() {
		const baseSize = 10;
		let scale = document.documentElement.clientWidth / 750;
		scale = scale > 1 ? 1 : scale;
		document.documentElement.style.fontSize = baseSize * scale + 'px';
	}

// 监听窗口变化
	window.addEventListener('resize', setRem);

// 页面加载时执行
	setRem();
})()
